module.exports = __webpack_public_path__ + "static/media/select.cbfde673.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/subscription/select.jpg
// module id = 2923
// module chunks = 0